/**
 * @desc 列表+详情
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.ResponseDto<
  Array<defs.basics.LogisticsAttrTypeDetailsResponseDto>
>;
export function request(
  body: defs.basics.LogisticsAttrTypeRequestParamsDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/logisticsAttrType/list/details`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
